<!-- Business Selection Dialog -->
<style>
  .business-selection-dialog .p-dropdown-panel {
    z-index: 10001 !important;
  }
  
  .business-selection-dialog .p-dropdown-items-wrapper {
    z-index: 10001 !important;
  }
  
  .business-selection-dialog .p-dropdown-overlay {
    z-index: 10001 !important;
  }
</style>

<p-dialog
  [header]="title | translate"
  [(visible)]="visible"
  (onVisibleChange)="onVisibleChange($event)"
  (onHide)="onDialogHide()"
  [modal]="true"
  [closable]="true"
  [resizable]="false"
  [draggable]="false"
  [style]="{ width: '500px' }"
  [baseZIndex]="10000"
  styleClass="business-selection-dialog"
>
  <div class="business-selection-content">
    <p class="mb-3" *ngIf="description" [translate]="description"></p>
    
    <div class="form-group">
      <label class="col-form-label">
        <span translate>BUSINESS</span>
        <span class="required" *ngIf="required">*</span>
      </label>
      <p-select
        [options]="availableBusinesses"
        [(ngModel)]="selectedBusiness"
        (onChange)="onBusinessChanged($event)"
        [style]="{ width: '100%' }"
        [disabled]="businessLoading || disabled"
        [placeholder]="placeholder | translate"
        [showClear]="showClear"
        [filter]="filter"
        [filterBy]="'label'"
        [filterPlaceholder]="filterPlaceholder | translate"
        dataKey="value"
        optionLabel="label"
        appendTo="body"
      ></p-select>
    </div>
  </div>
  
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="onCancel()"
        [translate]="cancelButtonText"
      >
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onConfirm()"
        [disabled]="isConfirmDisabled"
        [translate]="confirmButtonText"
      >
      </button>
    </div>
  </ng-template>
</p-dialog>
